'use es6';

import { createSelector } from 'reselect';
import { getUserId } from './auth';
export const getReviewsState = state => state.reviews;
export const getReviews = createSelector([getReviewsState], reviewsState => reviewsState.get('list'));
export const getReviewStats = createSelector([getReviewsState], reviewsState => reviewsState.get('stats'));
export const getReviewsTotal = createSelector([getReviewsState], reviewsState => reviewsState.get('total'));
export const getReviewSubmitted = createSelector([getReviewsState], reviewsState => reviewsState.get('reviewSubmitted')); // Selector factory enables us to pass props into useSelector and maintain memoization

export const makeGetUserMarkedHelpfulSelector = () => createSelector([getReviews, getUserId, (_, reviewId) => reviewId], (reviews, userId, reviewId) => {
  const review = reviews.find(rev => rev.get('id') === reviewId);
  return review && review.get('attributes').some(attr => attr.get('userId') === userId && attr.get('helpful'));
});
export const getReviewFilters = createSelector([getReviewsState], reviewsState => reviewsState.get('filters'));